import { render, staticRenderFns } from "./TopicItem.vue?vue&type=template&id=599f5adf&scoped=true&"
import script from "./TopicItem.vue?vue&type=script&lang=js&"
export * from "./TopicItem.vue?vue&type=script&lang=js&"
import style0 from "./TopicItem.vue?vue&type=style&index=0&id=599f5adf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599f5adf",
  null
  
)

export default component.exports